// Schema capabilities are not authorization. Every real read still uses its
// unchanged credentials and owner/scope variables and passes server guards.
const { partDetailsSelection } = require('../../../utils/recordingPartDetails');
const capabilityQuery = `query DashboardListCapabilities {
  room: __type(name: "Room") { fields { name } }
  rooms: __type(name: "SpecificRoomInput") { inputFields { name } }
  recordings: __type(name: "SpecificRecordingInput") { inputFields { name } }
  domains: __type(name: "SpecificAllowedDomainsInput") { inputFields { name } }
}`;
const readDashboardListCapabilities = async (baseUrl, fetchImpl, headers) => {
  try {
    const res = await fetchImpl(baseUrl, { method: 'POST', headers,
      body: JSON.stringify({ query: capabilityQuery }), signal: AbortSignal.timeout(5000) });
    const body = await res.json();
    if (!res.ok || body.errors?.length || !body.data) return { diagnostics: false, globalScope: false };
    const has = (name, kind, field) => Array.isArray(body.data[name]?.[kind]) &&
      body.data[name][kind].some(row => row?.name === field);
    return { diagnostics: has('room', 'fields', 'recordingPartDiagnostics'),
      globalScope: ['rooms', 'recordings', 'domains'].every(name => has(name, 'inputFields', 'globalScope')) };
  } catch (_) { return { diagnostics: false, globalScope: false }; }
};
const recordingRequestForCapabilities = (request, capabilities) => {
  if (capabilities?.diagnostics === true || typeof request?.query !== 'string' ||
      !/^\s*query RecordingsSpecific\b/.test(request.query) || !request.query.includes(partDetailsSelection)) return request;
  return Object.assign({}, request, { query: request.query.replace(partDetailsSelection, '') });
};
module.exports = { capabilityQuery, readDashboardListCapabilities, recordingRequestForCapabilities };
